export function accesGestionPrimes(utilisateur) {
  const role = String(utilisateur?.role || "").toLocaleLowerCase("fr-FR");
  return ["gestionnaire", "superviseur", "direction"].includes(role) || Boolean(utilisateur?.acces_primes);
}
